<template>
  <li class="list_once">
    <p class="p">如何分配权限给成员</p>
    <p class="text">1.在首页中点击“企业控制台”进入企业管理界面；</p>
    <img class="img" src="/images/home/sign_img7.png" alt="">
    <p class="text">2.点击“成员管理”，进入成员管理页面，点击在组织及成员菜单下，找到需要赋予权限的成员，点击分配权限</p>
    <img class="img" src="/images/home/sign_img8.png" alt="">
    <p class="text">3.勾选想要赋予成员的权限组（系统默认提供三个权限组，可按需定制，在权限组页面创建），点击确定。</p>
    <img class="img" src="/images/home/sign_img9.png" alt="">
  </li>
</template>
<script>
  export default {
    data () {
      // 这里存放数据
      return {}
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .list_once {
    font-size: 14px;
    padding: 10px;
    .p {
      font-size: 16px;
      font-weight: bold;
    }
    .text {
      margin: 10px 0;
    }
    .img {
      max-width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// pages/dingtalkUse/helpCenterCom/3_permsToMenber.vue